"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _Component2 = _interopRequireDefault(require("../../Component"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

var _Divider = _interopRequireDefault(require("../../Divider"));

var _index = _interopRequireDefault(require("../style/index"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Tab = _createStyled["default"].div(_templateObject()),
    Root = _createStyled["default"].div(_templateObject2()),
    TabsContainer = _createStyled["default"].div(_templateObject3());

var Main =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Main, _Component);

  function Main() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Main);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Main)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleTabClick", function (event, id) {
      var _this$props = _this.props,
          value = _this$props.value,
          autoFocus = _this$props.autoFocus;

      if (id !== value) {
        if (typeof _this.props.onChange === 'function') {
          _this.props.onChange(id);
        }
      }

      if (autoFocus && event.target) {
        event.target.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
          inline: 'center'
        });
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Main, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var styles = this.compileStyled(_index["default"]),
          _this$props2 = this.props,
          value = _this$props2.value,
          divider = _this$props2.divider;
      var tabs = null,
          children = this.props.children,
          active;
      children = _react["default"].Children.toArray(children);

      if (!value) {
        active = children[0];
      } else {
        active = children.find(function (item) {
          return item.props.id === value;
        });
      }

      if (children && children.length) {
        tabs = children.map(function (item, i) {
          var _item$props = item.props,
              _item$props$id = _item$props.id,
              id = _item$props$id === void 0 ? i : _item$props$id,
              _item$props$name = _item$props.name,
              name = _item$props$name === void 0 ? '' : _item$props$name,
              render = _item$props.render;
          return _react["default"].createElement(Tab, {
            key: id,
            styles: value === id ? styles.activeTab : styles.tab,
            onClick: function onClick(event) {
              return _this2._handleTabClick(event, id);
            }
          }, typeof render === 'function' ? render() : name);
        });
        tabs = _react["default"].createElement(TabsContainer, {
          styles: styles.tabsContainer
        }, tabs);
      }

      return _react["default"].createElement(Root, {
        styles: styles.root
      }, tabs, divider ? _react["default"].createElement(_Divider["default"], null) : null, active);
    }
  }]);
  return Main;
}(_Component2["default"]);

(0, _defineProperty2["default"])(Main, "propTypes", {
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  children: _propTypes["default"].any,
  divider: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  autoFocus: _propTypes["default"].bool,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.fontFamily
     */
    fontFamily: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default palette.tlNormal
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default flex-start
     */
    tabsJustifyContent: _propTypes["default"].string,

    /**
     * @default flex-end
     */
    tabsAlignItems: _propTypes["default"].string,

    /**
     * @default flex-start
     */
    tabJustifyContent: _propTypes["default"].string,

    /**
     * @default center
     */
    tabAlignItems: _propTypes["default"].string,

    /**
     * @default palette.gutter * 3 + 'px'
     */
    tabMarginRight: _propTypes["default"].string,

    /**
     * @default 3px
     */
    tabBorderWidth: _propTypes["default"].string,

    /**
     * @default solid
     */
    tabBorderStyle: _propTypes["default"].string,

    /**
     * @default transparent
     */
    tabBorderColor: _propTypes["default"].string,

    /**
     * @default palette.gutter * 3 + 'px'
     */
    tabPaddingTop: _propTypes["default"].string,

    /**
     * @default 21px
     */
    tabPaddingBottom: _propTypes["default"].string,

    /**
     * @default 0
     */
    tabPaddingLeft: _propTypes["default"].number,

    /**
     * @default 0
     */
    tabPaddingRight: _propTypes["default"].number,

    /**
     * @default palette.tInactive
     */
    tabColor: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    tabFontSize: _propTypes["default"].string,

    /**
     * @default 1.5
     */
    tabLineHeight: _propTypes["default"].number,

    /**
     * @default palette.twNormal
     */
    tabFontWeight: _propTypes["default"].number,

    /**
     * @default normal
     */
    tabCursor: _propTypes["default"].string,

    /**
     * @default 3px
     */
    activeTabBorderWidth: _propTypes["default"].string,

    /**
     * @default solid
     */
    activeTabBorderStyle: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    activeTabBorderColor: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    activeTabFontSize: _propTypes["default"].string,

    /**
     * @default 1.5
     */
    activeTabLineHeight: _propTypes["default"].number,

    /**
     * @default palette.twNormal
     */
    activeTabFontWeight: _propTypes["default"].number,

    /**
     * @default pointer
     */
    activeTabCursor: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    activeTabColor: _propTypes["default"].string,

    /**
     * @default 3px
     */
    hoverTabBorderWidth: _propTypes["default"].string,

    /**
     * @default solid
     */
    hoverTabBorderStyle: _propTypes["default"].string,

    /**
     * @default palette.elDarkest
     */
    hoverTabBorderColor: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    hoverTabFontSize: _propTypes["default"].string,

    /**
     * @default 1.5
     */
    hoverTabLineHeight: _propTypes["default"].number,

    /**
     * @default palette.twNormal
     */
    hoverTabFontWeight: _propTypes["default"].number,

    /**
     * @default pointer
     */
    hoverTabCursor: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    hoverTabColor: _propTypes["default"].string
  })
});
(0, _defineProperty2["default"])(Main, "defaultProps", {
  divider: true,
  autoFocus: false
});
(0, _defineProperty2["default"])(Main, "displayName", 'Tabs');
var _default = Main;
exports["default"] = _default;